import React from 'react';
import { beenHereBefore } from './../Services/beenHereBefore';
import { LandingGame } from './../Scenes/LandingGame/LandingGame';
import { About } from '../Scenes/About/About';

/**
 * Component that renders either the About scene
 * or LandingGame scene depending on whether the user
 * has visited before or not (using beenHereBefore service aka cookies)
 */
export const BeenHereBefore = props => {
  if (beenHereBefore()) {
    props.navigate('/about');
    return <About />;
  } else {
    return <LandingGame navigate={props.navigate} />;
  }
};
